import './AccountMain.css';
import CloseSave from '../../../design/close';
import AccountNames from './AccountNames';
import AccountEnd from './AccountEnd';
import AccountTotal from './AccountTotal';
import Massage from '../../../design/Massage';
import { useState } from 'react';


export default function AccountMain ({namesPaid, setNamesPaid, dataAccount, setClose, num_of_docket, namesInvoices, setNamesInvoices, names,
    organizeDataToSendToServer, updateDataDocketList, idAufa, projectId}) {

    const selectRadioObject = Object.fromEntries(Object.keys(names).map(key => [key, {select: false, radio: '1'}]));

    const [selectRadio, setSelectRadio] = useState(selectRadioObject);
    const [massage, setMassage] = useState({open: false, text: ''});

    return (
        <div className="main-docket account-inDocket">
            <div className='account-aufa-head'>
                <p> תשלום </p>
                <CloseSave setClose={setClose} fs='18pt' bc='azure' c='black' hbc='azure' hc='gray' bold={800} />
            </div>

            <div className='account-aufa-names'>
                <AccountNames 
                sum={dataAccount.sum} 
                sumR={dataAccount.sumR} 
                selectRadio={selectRadio} 
                setSelectRadio={setSelectRadio} 
                namesPaid={namesPaid}
                names={names}
                />
            </div>

            <div className='account-aufa-total'>
                <AccountTotal 
                selectRadio={selectRadio} 
                dataAccount={dataAccount}
                namesPaid={namesPaid}
                />
            </div>

            <div className='account-aufa-end'>
                <AccountEnd
                namesToSelect={selectRadio}
                namesToPaid={namesPaid}
                setNamesToPaid={setNamesPaid}
                dataAccount={dataAccount}
                num_of_docket={num_of_docket}
                namesInvoices={namesInvoices}
                setNamesInvoices={setNamesInvoices}
                names={names}
                organizeDataToSendToServer={organizeDataToSendToServer}
                setMassage={setMassage}
                updateDataDocketList={updateDataDocketList}
                idAufa={idAufa}
                projectId={projectId}
                setSelectRadio={() => setSelectRadio(selectRadioObject)}
                />
            </div>

            {
                massage.open && 
                <Massage 
                text={massage.text} 
                setClose={() => setMassage({open: false, text: ""})} 
                animation={true} 
                />
            }
        </div>
    )
}